import Cookies from 'js-cookie';

import { LANGUAGE_COOKIE_KEY, LANGUAGE_COOKIE_OPTIONS } from '../constants';
import type { Language } from '../models';
import { ensureEndsWith } from './ensureEndsWith';
import { getLanguageCodeAbbreviation } from './getLanguageCodeAbbreviation';
import { getLegacyCookieName } from './getLegacyCookieName';
import { isDefaultLanguage } from './isDefaultLanguage';

const ensureEndsWithSlash = (value: string) => ensureEndsWith(value, '/');
export const ERROR_MISSING_CODE = 'Cannot change to new language as it has missing code';
/**
 * Changes language to provided value by saving it to cookies and redirecting to appropriate URL, if needed.
 *
 * @param nextLanguage
 * @param currentLanguage
 * @param tenant
 */
// eslint-disable-next-line max-params -- Nope
export function changeLanguage(
  nextLanguage: Language,
  currentLanguage: string,
  tenant: string,
  /**
   * If pathname should be changed to new language, if false then only cookies are changed
   */
  changePath = true,
) {
  const legacyCookieName = getLegacyCookieName(tenant);

  if (!nextLanguage.code) {
    throw new Error(ERROR_MISSING_CODE);
  }

  Cookies.set(LANGUAGE_COOKIE_KEY, nextLanguage.code, LANGUAGE_COOKIE_OPTIONS);
  // Set also an older Online cookie to make this compatible on older pages.
  Cookies.set(legacyCookieName, nextLanguage.code, LANGUAGE_COOKIE_OPTIONS);

  if (changePath) {
    // Get language code abbreviation by removing the 2nd country part.
    const languageCodeAbbrev = getLanguageCodeAbbreviation(nextLanguage.code);

    // Create a new pathname from current pathname and ensure that it ends with slash
    let newPathName = ensureEndsWithSlash(window.location.pathname);

    // Remove current language from pathname, if any.
    newPathName = newPathName.replace(new RegExp(`^/${getLanguageCodeAbbreviation(currentLanguage)}/`), '/');

    // If a selected language is not the default one, add its abbrev to the start of pathname.
    if (!isDefaultLanguage(nextLanguage)) {
      newPathName = `/${languageCodeAbbrev}${newPathName || '/'}`;
    }

    // Reload page and make sure that it ends with slash again
    window.location.pathname = ensureEndsWithSlash(newPathName);
  }
}
